import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useAnalytics } from '@lusha-engage/analytics';
import { Button } from '@lusha-ui/button';
import { Text } from '@lusha-ui/text';
import React, { useState } from 'react';
import RateStars from '../components/RateStars';
function RateView(props) {
    const { onRateSubmit } = props;
    const [rate, setRate] = useState(null);
    const analytics = useAnalytics();
    function handleRateNow() {
        if (rate !== null) {
            onRateSubmit(rate);
            analytics.track({
                eventType: 'feedback_rating_completed',
                event_value: rate,
            });
        }
    }
    return (_jsxs("div", { children: [_jsx(Text, { variant: 'large20B', display: 'block', textAlign: 'center', css: css `
          margin-bottom: 4px;
        `, children: "Enjoying the extension?" }), _jsx(Text, { variant: 'small14R', display: 'block', textAlign: 'center', nowrap: true, children: "We\u2019d love to hear how satisfied you are" }), _jsx(RateStars, { onRateChange: setRate }), _jsx("div", { css: css `
          padding: 0 24px;
          margin-top: 32px;
        `, children: _jsx(Button, { size: 'small', onClick: handleRateNow, disabled: !rate, width: '100%', children: "Rate now" }) })] }));
}
export default RateView;
